import { useMutation } from 'react-query';
import { httpClient } from '@vs-online-only-app/state';

export interface MediaItem {
  mediaUrl: string;
  contentType: string;
  type: 'photo' | 'video';
  cacheUri?: string;
  filename: string;
}

interface Location {
  lon: number;
  lat: number;
}

interface InviteItem {
  title: string;
  location?: Location;
  address?: string;
  placeName?: string;
}

interface SendContactEmailPayload {
  text: string;
  media?: MediaItem[];
  invites?: InviteItem[];
  products?: string[];
}

interface SendContactEmailVariables {
  contactId: string;
  payload: SendContactEmailPayload;
}

export const useSendContactEmail = () => {
  return useMutation(
    ['sendContactEmail'],
    async ({ contactId, payload }: SendContactEmailVariables) => {
      const response = await httpClient.post(
        `/contacts/${contactId}/email`,
        payload,
      );
      return response.data;
    },
  );
};
